/**
 * @owner @Appboy/reporting
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/campaign_canvas_credit_consumption_detail_data" endpoint
 */
import { isCampaignCanvasConsumptionResult } from "@dashboardApi/apis/campaignCanvasConsumption/validators";

import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { campaignCanvasConsumption } from "./constants";
import type { CampaignCanvasConsumptionParams, CampaignCanvasConsumptionResult } from "./types";

export const getDataTableCampaignCanvasConsumption = reactQueryTableFetcherAdapter(
  campaignCanvasConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0, metric }: CampaignCanvasConsumptionParams
  ): Promise<CampaignCanvasConsumptionResult> => {
    const { start_date, end_date } = query ?? {};

    return fetch(
      `/analytics_dashboard/${appGroupId}/campaign_canvas_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        metric,
      },
      { signal }
    );
  },
  isCampaignCanvasConsumptionResult
);
